import { gql } from '@apollo/client';

export const PROFILE_FRAGMENT = gql`
  fragment ProfileFragment on ParsedProfileResponse {
    content_is_cv
    profile {
      name
      photoUrl
      headline
      summary_recommendation
      summary_quality_percentage
      summary
      location {
        city
        province
        country
      }
      experiences {
        logo
        title
        companyName
        startDate
        endDate
        date_recommendation
        workPlace
        location {
          city
          province
          country
        }
        description
        description_recommendation
        description_quality_percentage
        skills
      }
      educations {
        school
        degree
        title
        school
        description
        description_recommendation
        description_quality_percentage
        startDate
        endDate
        date_recommendation
      }
      skills
      languages {
        language
        level
        speaking_level
        writing_level
      }
      certifications {
        title
        deliveredBy
        url
        date
      }
      phone
      email
    }
  }
`;

export const PARSE_CV_MUTATION = gql`
  mutation parseCV($file: Upload!) {
    parseCV(file: $file) {
      ...ProfileFragment
    }
  }
  ${PROFILE_FRAGMENT}
`;

export const EVALUATE_CV_MUTATION = gql`
  mutation evaluateProfile($profile: String!) {
    evaluateProfile(profile: $profile) {
      ...ProfileFragment
    }
  }
  ${PROFILE_FRAGMENT}
`;

export const GENERATE_ALL_CONTENT_MUTATION = gql`
  mutation generateAll($input: GenerateContentRequest!) {
    generateContent(input: $input, language: "fr") {
      cv {
        email
        summary
        summary_improvement
        experiences_improvement
        educations_improvement
        experiences {
          logo
          title
          companyName
          startDate
          endDate
          date_recommendation
          workPlace
          location {
            city
            province
            country
          }
          description
          description_recommendation
          description_quality_percentage
          skills
        }
        educations {
          school
          degree
          title
          school
          description
          description_recommendation
          description_quality_percentage
          startDate
          endDate
          date_recommendation
        }
        skills
      }
      motivation_letter {
        content
        improvement
      }
    }
  }
`;

export const MODIFY_SECTION_MUTATION = gql`
  mutation modifySection(
    $content: String!
    $instructions: String!
    $jobDescription: String!
    $type: ModifySectionType!
  ) {
    modifySection(
      content: $content
      instructions: $instructions
      jobDescription: $jobDescription
      type: $type
    ) {
      content
      improvement
    }
  }
`;

export const UPDATE_CV_MUTATION = gql`
  mutation updateCv($instructions: String!, $jobDescription: String!, $profile: String!) {
    updateCv(instructions: $instructions, jobDescription: $jobDescription, profile: $profile) {
      email
      summary
      summary_improvement
      experiences_improvement
      educations_improvement
      experiences {
        logo
        title
        companyName
        startDate
        endDate
        date_recommendation
        workPlace
        location {
          city
          province
          country
        }
        description
        description_recommendation
        description_quality_percentage
        skills
      }
      educations {
        school
        degree
        title
        school
        description
        description_recommendation
        description_quality_percentage
        startDate
        endDate
        date_recommendation
      }
      skills
    }
  }
`;
